//==========import components===============

const CommonDetail = ({ data, whiteText }) => {
  return (
    <section className='commonDetailSec DBlock py-10 sm:py-12 px-6 sm:px-10'>
      <div className='max-w-7xl mx-auto'>
        <div className=' grid grid-cols-1 lg:grid-cols-2 gap-6 relative z-1'>
          <div className="flex flex-col">
            <h1
              className={`heading uppercase ${
                whiteText ? 'text-white' : 'text-black'
              } font-bold text-lg sm:text-2xl lg:text-3xl  xl:text-4xl`}
            >
              {data[0]?.middleTitle ? (
                data[0]?.middleTitle
              ) : (
                <div>
                  <span>join</span>
                  <span className='text-eventLightYellow px-2'>
                    {data[0]?.joinEventTitle.slice(5, 17)}
                  </span>
                  <span>{data[0]?.joinEventTitle.slice(18)}</span>
                </div>
              )}
            </h1>
            <h3
              className={`relative uppercase flex flex-wrap float-left ${
                whiteText ? 'text-white' : 'text-eventGray'
              } text-sm lg:text-base lg:-right-20 sm:-top-3 sm:-right-16 top-0 right-0 sm:pt-0 pt-1`}
            >
              {data[0]?.lowerTitle ? (
                data[0].lowerTitle
              ) : (
                <span className='capitalize'>{data[0]?.ceoDesignation}</span>
              )}
            </h3>
            <p className='text-sm sm:text-base text-eventGray py-4'>
              {data[0]?.desc}
            </p>
          </div>
          <div>
            <img
              src='/assets/images/portfolio/privateBirthdayParty/mayon/2.png'
              alt='eventImg'
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommonDetail;
